export enum RouteVisibility {
  Public = 'Public',
  Confidential = 'Confidential',
  Private = 'Private',
}
